var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import Button from 'syf-component-library/ui/atoms/Button';
import query from 'syf-component-library/const/mediaQueries';
export var FooterButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media ", " {\n    min-width: 100%;\n  }\n"], ["\n  @media ", " {\n    min-width: 100%;\n  }\n"])), query.lessThanSmall);
var templateObject_1;
